
import { defineComponent, reactive } from 'vue'
import { useRouter } from 'vue-router'

// module components
import SignInForm from '@/modules/AuthModule/components/SignInForm/index.vue'
import RestoreForm from '@/modules/AuthModule/components/RestoreForm/index.vue'

// composable
import useAuth from '@/common/composable/useAuth'
import useAccount from '@/common/composable/useAccount'
import useNotifications from '@/common/composable/useNotifications'

// types
import { AuthSignInPayloadT } from '@/core/types/auth.types'

// realisations
import { authRealisation } from '@/core/realisations/auth.realisation'

export default defineComponent({
    components: {
        'sign-in-form': SignInForm,
        'restore-form': RestoreForm,
    },
    setup() {
        const state = reactive({
            is_loading: false,
            is_on_sign_in: true,
        })

        const router = useRouter()
        const { setAuthorization } = useAuth()
        const notifications = useNotifications()

        const account = useAccount()

        const signInHandler = async (signin_payload: AuthSignInPayloadT) => {
            try {
                state.is_loading = true
                const response = await authRealisation.signin(signin_payload)
                setAuthorization(response)
                
                await account.reset()
                await account.initialize()

                await router.push('/')
            } catch (error) {
                notifications.notifyError({ error, title: 'Ошибка при авторизации' })
            } finally {
                state.is_loading = false
            }
        }

        const toggleRestore = () => {
            state.is_on_sign_in = !state.is_on_sign_in
        }

        return { state, signInHandler, toggleRestore }
    },
})
